import { ReactElement } from "react"

import { UseQueryResult } from "@tanstack/react-query"

import { Spinner } from "@/components/ui/Spinner"
import { ErrorState } from "@/src/components"

export function Loader<TData, TError>({
  result,
  render,
  fallback,
}: {
  result: UseQueryResult<TData, TError>
  render: (props: { data: TData }) => ReactElement | null
  /**
   * Shown while loading, in place of the spinner. Pass a skeleton of what is
   * being loaded when the spinner would otherwise replace something already on
   * screen -- a card that vanishes and comes back reads as the page breaking,
   * where a card that fills in reads as the page working.
   */
  fallback?: ReactElement | null
}) {
  const { data, isLoading, error } = result
  if (error)
    return <ErrorState title={"Hit an error while fetching data"} rawError={error} />
  if (isLoading) return fallback ?? <Spinner className="m-4" />
  if (!data) return <>No data 🫠</>

  return render({ data })
}
